export default __webpack_public_path__ + "static/media/rank-drop-rank.bcf8bb27.png";